<template>
  <div
    class="relative flex items-center justify-center flex-shrink-0"
    :style="sizeStyle"
  >
    <div
      class="absolute inset-0 rounded-full"
      :style="{
        background: `conic-gradient(${progressColor} 0deg ${progressDegrees}deg, ${trailColor} ${progressDegrees}deg 360deg)`
      }"
    ></div>
    <div
      class="absolute rounded-full bg-white"
      :style="{
        inset: `${innerPadding}px`
      }"
    ></div>
    <div class="relative text-center">
      <slot>
        <div class="text-base font-semibold text-gray-900 leading-tight">
          {{ displayValue }}
        </div>
        <div class="text-xs text-gray-500 leading-tight">
          {{ displayLabel }}
        </div>
      </slot>
    </div>
  </div>
</template>

<script>
export default {
  name: "CircleProgress",
  props: {
    value: {
      type: Number,
      default: 0
    },
    total: {
      type: Number,
      default: 100
    },
    color: {
      type: String,
      default: "#10b981"
    },
    trailColor: {
      type: String,
      default: "#E5E7EB"
    },
    size: {
      type: String,
      default: "md"
    },
    innerPadding: {
      type: Number,
      default: 10
    },
    label: {
      type: String,
      default: ""
    },
    showPercent: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    percentage() {
      if (!this.total) {
        return 0;
      }
      const percent = (this.value / this.total) * 100;
      return Math.min(100, Math.max(0, Math.round(percent)));
    },
    progressDegrees() {
      return (this.percentage / 100) * 360;
    },
    progressColor() {
      return this.color;
    },
    displayValue() {
      return this.showPercent ? `${this.percentage}%` : this.value;
    },
    displayLabel() {
      return this.label;
    },
    sizeStyle() {
      const sizeMap = {
        sm: 56,
        md: 72,
        lg: 96
      };
      const dimension = sizeMap[this.size] || sizeMap.md;
      return {
        width: `${dimension}px`,
        height: `${dimension}px`
      };
    }
  }
};
</script>
